






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {BaseFretebas} from '@/model/resource/BaseFretebas'
import {InputBaseFretebasSchema} from '@/schema/resource/BaseFretebas/InputBaseFretebasSchema'

@Component
export default class PersistBaseFretebasView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputBaseFretebasSchema()
  baseFretebas = new BaseFretebas()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.baseFretebas.getBaseFretebas(id)
    }

    $.await.done('getBaseFretebas')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.baseFretebas.persistBaseFretebas()
    await Helper.successAndPush('system.success.persist', '/base-fretebas/list')
  }
}
